export default "__VITE_ASSET__a4eeb73a__"